export const environment = {
  production: true,
  apiUrl: 'https://api.winwithdash.com/v4',
  baseUrl: 'https://api.winwithdash.com/api',
  pubKey: 'pub-c-4f30f187-bf5c-42ac-bfe9-08e3bb196279',
  subKey: 'sub-c-ddd097de-6e8a-11e5-86f5-0619f8945a4f',
  mixpanelToken: 'f9cda7ad9c7b15c7e0fde063159fc845',
  assetsUrl: 'https://assets.winwithdash.com',
  sentryDns: 'https://46e179b3ec4544a6a8fb370d43be2afd@o138343.ingest.sentry.io/6189343',
  appId: 'dash',
  firebase: {
    apiKey: 'AIzaSyBaAqbS3hhaZegb5xmqpZlcmjRN-W3nqwM',
    authDomain: 'dash-production.firebaseapp.com',
    databaseURL: 'https://dash-production.firebaseio.com',
    projectId: 'dash-production',
    storageBucket: 'dash-production.appspot.com',
    messagingSenderId: '1058188252524',
    appId: '1:1058188252524:web:4a7045334104b4b4eacf49',
    measurementId: 'G-B2E3FK60HN',
    vapidKey:
      'BFvprYc4OrPY44hTveO_qapEaorBiZc954WkoSoNDQWqSjeef3OEIph_1qJ6d_Da1zw_bFM17M8cm0Jt0QfaKa0',
  },
  turnstileKey: '0x4AAAAAABA38DUFqgq7ftYZ',
};
